import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import FormField from 'components/FormField';
import Text from 'components/Text';
import TimeZonePickerModal from 'screens/TimeZonePickerModal';
import Flex from 'components/Flex';
import AddOrEditButton from '../utils/AddOrEditButton';
var TimeZoneField = function TimeZoneField(_ref) {
  var _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    onChange = _ref.onChange,
    id = _ref.id,
    value = _ref.value,
    alert = _ref.alert,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    description = _ref.description,
    descriptionType = _ref.descriptionType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTimezonePickerOpen = _useState2[0],
    setTimezonePickerOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(FormField, {
    as: "span",
    label: t('form_time_zone'),
    labelId: uniqueId,
    horizontal: horizontal,
    description: description,
    descriptionType: descriptionType,
    alert: alert
  }, /*#__PURE__*/React.createElement(Flex, {
    wrap: true
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "s",
    mr: "xxs"
  }, value !== null && value !== void 0 ? value : t('state_none_utc')), /*#__PURE__*/React.createElement(AddOrEditButton, {
    isEditMode: !!value,
    addText: t('actions_add_timezone'),
    editText: t('actions_edit_timezone'),
    variant: variant,
    onClick: function onClick() {
      return setTimezonePickerOpen(true);
    }
  })), isTimezonePickerOpen && /*#__PURE__*/React.createElement(TimeZonePickerModal, {
    selected: value,
    onSubmit: function onSubmit(selectedTimeZone) {
      onChange(selectedTimeZone);
      setTimezonePickerOpen(false);
    },
    onClose: function onClose() {
      return setTimezonePickerOpen(false);
    }
  }));
};
export default TimeZoneField;